"use strict";
/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockPostCreditFacilityPaymentRequestSuccess = exports.fetchPostCreditFacilityPaymentRequest = exports.mockPostCreditFacilityPaymentRequestByPaymentMethodIdFailure = exports.mockPostCreditFacilityPaymentRequestByPaymentMethodIdSuccess = exports.fetchPostCreditFacilityPaymentRequestByPaymentMethodId = exports.mockPostCreditFacilityFundingRequestFailure = exports.mockPostCreditFacilityFundingRequestSuccess = exports.fetchPostCreditFacilityFundingRequest = exports.mockGetCreditFacilityFeaturesFailure = exports.mockGetCreditFacilityFeaturesSuccess = exports.fetchGetCreditFacilityFeatures = exports.mockGetCreditFacilityCustomerDocumentDownloadFailure = exports.mockGetCreditFacilityCustomerDocumentDownloadSuccess = exports.fetchGetCreditFacilityCustomerDocumentDownload = exports.mockPutCreditFacilityCustomerDocumentFailure = exports.mockPutCreditFacilityCustomerDocumentSuccess = exports.fetchPutCreditFacilityCustomerDocument = exports.mockGetCreditFacilityCustomerDocumentFailure = exports.mockGetCreditFacilityCustomerDocumentSuccess = exports.fetchGetCreditFacilityCustomerDocument = exports.mockGetContextFailure = exports.mockGetContextSuccess = exports.fetchGetContext = exports.mockGetContextByStateKeyFailure = exports.mockGetContextByStateKeySuccess = exports.fetchGetContextByStateKey = exports.mockGetCompanySearchFailure = exports.mockGetCompanySearchSuccess = exports.fetchGetCompanySearch = exports.mockPostChallengeResponseFailure = exports.mockPostChallengeResponseSuccess = exports.fetchPostChallengeResponse = exports.mockGetChallengeResponseFailure = exports.mockGetChallengeResponseSuccess = exports.fetchGetChallengeResponse = exports.mockGetAssociatedPeopleFailure = exports.mockGetAssociatedPeopleSuccess = exports.fetchGetAssociatedPeople = exports.mockPostApprovalRequestFailure = exports.mockPostApprovalRequestSuccess = exports.fetchPostApprovalRequest = exports.mockPostApprovalProbabilityFailure = exports.mockPostApprovalProbabilitySuccess = exports.fetchPostApprovalProbability = exports.mockGetAccountStatementFailure = exports.mockGetAccountStatementSuccess = exports.fetchGetAccountStatement = exports.mockLendingApi = exports.fetchLendingAPIJSON = exports.fetchLendingAPI = void 0;
exports.fetchPostPasswordReset = exports.mockPostPasswordChangeFailure = exports.mockPostPasswordChangeSuccess = exports.fetchPostPasswordChange = exports.mockPostOutstandingCbilsOrBblFailure = exports.mockPostOutstandingCbilsOrBblSuccess = exports.fetchPostOutstandingCbilsOrBbl = exports.mockGetOutstandingCbilsOrBblFailure = exports.mockGetOutstandingCbilsOrBblSuccess = exports.fetchGetOutstandingCbilsOrBbl = exports.mockGetOnlineAccountFailure = exports.mockGetOnlineAccountSuccess = exports.fetchGetOnlineAccount = exports.mockPostOnfidoSmsFailure = exports.mockPostOnfidoSmsSuccess = exports.fetchPostOnfidoSms = exports.mockPostLogoutFailure = exports.mockPostLogoutSuccess = exports.fetchPostLogout = exports.mockGetLoginLinkFailure = exports.mockGetLoginLinkSuccess = exports.fetchGetLoginLink = exports.mockPostLoginFailure = exports.mockPostLoginSuccess = exports.fetchPostLogin = exports.mockGetGeneralDocumentDownloadFailure = exports.mockGetGeneralDocumentDownloadSuccess = exports.fetchGetGeneralDocumentDownload = exports.mockGetFundingRequirementFailure = exports.mockGetFundingRequirementSuccess = exports.fetchGetFundingRequirement = exports.mockGetEmailAvailabilityFailure = exports.mockGetEmailAvailabilitySuccess = exports.fetchGetEmailAvailability = exports.mockPutDocumentUploadFailure = exports.mockPutDocumentUploadSuccess = exports.fetchPutDocumentUpload = exports.mockPostDocumentUploadFailure = exports.mockPostDocumentUploadSuccess = exports.fetchPostDocumentUpload = exports.mockGetDocumentUploadFailure = exports.mockGetDocumentUploadSuccess = exports.fetchGetDocumentUpload = exports.mockGetCreditFacilityStatusFailure = exports.mockGetCreditFacilityStatusSuccess = exports.fetchGetCreditFacilityStatus = exports.mockGetCreditFacilityRepaymentScheduleFailure = exports.mockGetCreditFacilityRepaymentScheduleSuccess = exports.fetchGetCreditFacilityRepaymentSchedule = exports.mockPostCreditFacilityPaymentRequestFailure = void 0;
exports.mockPutStateFailure = exports.mockPutStateSuccess = exports.fetchPutState = exports.mockGetStateFailure = exports.mockGetStateSuccess = exports.fetchGetState = exports.mockGetStateByStateKeyFailure = exports.mockGetStateByStateKeySuccess = exports.fetchGetStateByStateKey = exports.mockPostStateFailure = exports.mockPostStateSuccess = exports.fetchPostState = exports.mockGetReportFailure = exports.mockGetReportSuccess = exports.fetchGetReport = exports.mockPostRepaymentPaymentMethodFailure = exports.mockPostRepaymentPaymentMethodSuccess = exports.fetchPostRepaymentPaymentMethod = exports.mockGetRepaymentPaymentMethodFailure = exports.mockGetRepaymentPaymentMethodSuccess = exports.fetchGetRepaymentPaymentMethod = exports.mockPostRepaymentPaymentIntentFailure = exports.mockPostRepaymentPaymentIntentSuccess = exports.fetchPostRepaymentPaymentIntent = exports.mockGetRepaymentPaymentIntentFailure = exports.mockGetRepaymentPaymentIntentSuccess = exports.fetchGetRepaymentPaymentIntent = exports.mockGetPostcodeLookupFailure = exports.mockGetPostcodeLookupSuccess = exports.fetchGetPostcodeLookup = exports.mockPutPaymentMethodFailure = exports.mockPutPaymentMethodSuccess = exports.fetchPutPaymentMethod = exports.mockPostPaymentMethodFailure = exports.mockPostPaymentMethodSuccess = exports.fetchPostPaymentMethod = exports.mockGetPaymentMethodFailure = exports.mockGetPaymentMethodSuccess = exports.fetchGetPaymentMethod = exports.mockPostPaymentConfirmationFailure = exports.mockPostPaymentConfirmationSuccess = exports.fetchPostPaymentConfirmation = exports.mockGetPaymentConfirmationFailure = exports.mockGetPaymentConfirmationSuccess = exports.fetchGetPaymentConfirmation = exports.mockPostPasswordResetFailure = exports.mockPostPasswordResetSuccess = void 0;
const lendingAPI_1 = require("./lendingAPI");
const lendingAPIMock_1 = require("./lendingAPIMock");
var lendingAPI_2 = require("./lendingAPI");
Object.defineProperty(exports, "fetchLendingAPI", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPI; } });
Object.defineProperty(exports, "fetchLendingAPIJSON", { enumerable: true, get: function () { return lendingAPI_2.fetchLendingAPIJSON; } });
var lendingAPIMock_2 = require("./lendingAPIMock");
Object.defineProperty(exports, "mockLendingApi", { enumerable: true, get: function () { return lendingAPIMock_2.mockLendingApi; } });
const failureResponse = {
    errors: [
        {
            code: "PermissionDenied",
            detail: "You do not have permission to perform this action.",
        },
    ],
};
/**
 * No description
 */
function fetchGetAccountStatement({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/account_statement/${stateKey}/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetAccountStatement = fetchGetAccountStatement;
function mockGetAccountStatementSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/account_statement/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetAccountStatementSuccess = mockGetAccountStatementSuccess;
function mockGetAccountStatementFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/account_statement/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetAccountStatementFailure = mockGetAccountStatementFailure;
/**
 * No description
 */
function fetchPostApprovalProbability({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/approval_probability/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostApprovalProbability = fetchPostApprovalProbability;
function mockPostApprovalProbabilitySuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/approval_probability/`, "post", 200, data, options);
}
exports.mockPostApprovalProbabilitySuccess = mockPostApprovalProbabilitySuccess;
function mockPostApprovalProbabilityFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/approval_probability/`, "post", 400, failureResponse, options);
}
exports.mockPostApprovalProbabilityFailure = mockPostApprovalProbabilityFailure;
/**
 * This method should be used when a decision needs to be made for a customer. It doesn&#x27;t expect any payload, all needed information should have been provided in the state of the customer.
 */
function fetchPostApprovalRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/approval_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostApprovalRequest = fetchPostApprovalRequest;
function mockPostApprovalRequestSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/approval_request/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostApprovalRequestSuccess = mockPostApprovalRequestSuccess;
function mockPostApprovalRequestFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/approval_request/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostApprovalRequestFailure = mockPostApprovalRequestFailure;
/**
 * Retrieve the people associated with the company on the application.
 */
function fetchGetAssociatedPeople({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/associated_people/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetAssociatedPeople = fetchGetAssociatedPeople;
function mockGetAssociatedPeopleSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/associated_people/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetAssociatedPeopleSuccess = mockGetAssociatedPeopleSuccess;
function mockGetAssociatedPeopleFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/associated_people/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetAssociatedPeopleFailure = mockGetAssociatedPeopleFailure;
/**
 * No description
 */
function fetchGetChallengeResponse({ stateKey, personUid, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/challenge_response/${stateKey}/${personUid}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetChallengeResponse = fetchGetChallengeResponse;
function mockGetChallengeResponseSuccess(stateKey, personUid, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/challenge_response/${stateKey}/${personUid}/`, "get", 200, data, options);
}
exports.mockGetChallengeResponseSuccess = mockGetChallengeResponseSuccess;
function mockGetChallengeResponseFailure(stateKey, personUid, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/challenge_response/${stateKey}/${personUid}/`, "get", 400, failureResponse, options);
}
exports.mockGetChallengeResponseFailure = mockGetChallengeResponseFailure;
/**
 * No description
 */
function fetchPostChallengeResponse({ stateKey, personUid, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/challenge_response/${stateKey}/${personUid}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostChallengeResponse = fetchPostChallengeResponse;
function mockPostChallengeResponseSuccess(stateKey, personUid, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/challenge_response/${stateKey}/${personUid}/`, "post", 200, data, options);
}
exports.mockPostChallengeResponseSuccess = mockPostChallengeResponseSuccess;
function mockPostChallengeResponseFailure(stateKey, personUid, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/challenge_response/${stateKey}/${personUid}/`, "post", 400, failureResponse, options);
}
exports.mockPostChallengeResponseFailure = mockPostChallengeResponseFailure;
/**
 * No description
 */
function fetchGetCompanySearch({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/company_search/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCompanySearch = fetchGetCompanySearch;
function mockGetCompanySearchSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/company_search/`, "get", 200, data, options);
}
exports.mockGetCompanySearchSuccess = mockGetCompanySearchSuccess;
function mockGetCompanySearchFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/company_search/`, "get", 400, failureResponse, options);
}
exports.mockGetCompanySearchFailure = mockGetCompanySearchFailure;
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContextByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/context/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetContextByStateKey = fetchGetContextByStateKey;
function mockGetContextByStateKeySuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/context/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetContextByStateKeySuccess = mockGetContextByStateKeySuccess;
function mockGetContextByStateKeyFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/context/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetContextByStateKeyFailure = mockGetContextByStateKeyFailure;
/**
 * Collection of attributes to operate with iwoca&#x27;s lending API.
 */
function fetchGetContext({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/context/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetContext = fetchGetContext;
function mockGetContextSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/context/`, "get", 200, data, options);
}
exports.mockGetContextSuccess = mockGetContextSuccess;
function mockGetContextFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/context/`, "get", 400, failureResponse, options);
}
exports.mockGetContextFailure = mockGetContextFailure;
/**
 * No description
 */
function fetchGetCreditFacilityCustomerDocument({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_customer_document/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityCustomerDocument = fetchGetCreditFacilityCustomerDocument;
function mockGetCreditFacilityCustomerDocumentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityCustomerDocumentSuccess = mockGetCreditFacilityCustomerDocumentSuccess;
function mockGetCreditFacilityCustomerDocumentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityCustomerDocumentFailure = mockGetCreditFacilityCustomerDocumentFailure;
/**
 * No description
 */
function fetchPutCreditFacilityCustomerDocument({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_customer_document/${stateKey}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutCreditFacilityCustomerDocument = fetchPutCreditFacilityCustomerDocument;
function mockPutCreditFacilityCustomerDocumentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutCreditFacilityCustomerDocumentSuccess = mockPutCreditFacilityCustomerDocumentSuccess;
function mockPutCreditFacilityCustomerDocumentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutCreditFacilityCustomerDocumentFailure = mockPutCreditFacilityCustomerDocumentFailure;
/**
 * No description
 */
function fetchGetCreditFacilityCustomerDocumentDownload({ stateKey, documentId, query, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_customer_document/${stateKey}/${documentId}/download/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCreditFacilityCustomerDocumentDownload = fetchGetCreditFacilityCustomerDocumentDownload;
function mockGetCreditFacilityCustomerDocumentDownloadSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/${documentId}/download/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityCustomerDocumentDownloadSuccess = mockGetCreditFacilityCustomerDocumentDownloadSuccess;
function mockGetCreditFacilityCustomerDocumentDownloadFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_customer_document/${stateKey}/${documentId}/download/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityCustomerDocumentDownloadFailure = mockGetCreditFacilityCustomerDocumentDownloadFailure;
/**
 * The data returned contains general information about credit, ...
 */
function fetchGetCreditFacilityFeatures({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_features/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityFeatures = fetchGetCreditFacilityFeatures;
function mockGetCreditFacilityFeaturesSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_features/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityFeaturesSuccess = mockGetCreditFacilityFeaturesSuccess;
function mockGetCreditFacilityFeaturesFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_features/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityFeaturesFailure = mockGetCreditFacilityFeaturesFailure;
/**
 * No description
 */
function fetchPostCreditFacilityFundingRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/credit_facility_funding_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityFundingRequest = fetchPostCreditFacilityFundingRequest;
function mockPostCreditFacilityFundingRequestSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_funding_request/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostCreditFacilityFundingRequestSuccess = mockPostCreditFacilityFundingRequestSuccess;
function mockPostCreditFacilityFundingRequestFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_funding_request/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostCreditFacilityFundingRequestFailure = mockPostCreditFacilityFundingRequestFailure;
/**
 * No description
 */
function fetchPostCreditFacilityPaymentRequestByPaymentMethodId({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_payment_request/${stateKey}/${paymentMethodId}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityPaymentRequestByPaymentMethodId = fetchPostCreditFacilityPaymentRequestByPaymentMethodId;
function mockPostCreditFacilityPaymentRequestByPaymentMethodIdSuccess(stateKey, paymentMethodId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_payment_request/${stateKey}/${paymentMethodId}/`, "post", 201, data, options);
}
exports.mockPostCreditFacilityPaymentRequestByPaymentMethodIdSuccess = mockPostCreditFacilityPaymentRequestByPaymentMethodIdSuccess;
function mockPostCreditFacilityPaymentRequestByPaymentMethodIdFailure(stateKey, paymentMethodId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_payment_request/${stateKey}/${paymentMethodId}/`, "post", 400, failureResponse, options);
}
exports.mockPostCreditFacilityPaymentRequestByPaymentMethodIdFailure = mockPostCreditFacilityPaymentRequestByPaymentMethodIdFailure;
/**
 * No description
 */
function fetchPostCreditFacilityPaymentRequest({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_payment_request/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostCreditFacilityPaymentRequest = fetchPostCreditFacilityPaymentRequest;
function mockPostCreditFacilityPaymentRequestSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_payment_request/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostCreditFacilityPaymentRequestSuccess = mockPostCreditFacilityPaymentRequestSuccess;
function mockPostCreditFacilityPaymentRequestFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_payment_request/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostCreditFacilityPaymentRequestFailure = mockPostCreditFacilityPaymentRequestFailure;
/**
 * Returning the repayment schedule for a customer, with possible early repayment or new draw-down simulation.
 */
function fetchGetCreditFacilityRepaymentSchedule({ stateKey, query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_repayment_schedule/${stateKey}/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetCreditFacilityRepaymentSchedule = fetchGetCreditFacilityRepaymentSchedule;
function mockGetCreditFacilityRepaymentScheduleSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_repayment_schedule/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityRepaymentScheduleSuccess = mockGetCreditFacilityRepaymentScheduleSuccess;
function mockGetCreditFacilityRepaymentScheduleFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_repayment_schedule/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityRepaymentScheduleFailure = mockGetCreditFacilityRepaymentScheduleFailure;
/**
 * The data returned contains information like approval status, loan status, repayments, cashflows, ...
 */
function fetchGetCreditFacilityStatus({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/credit_facility_status/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetCreditFacilityStatus = fetchGetCreditFacilityStatus;
function mockGetCreditFacilityStatusSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_status/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetCreditFacilityStatusSuccess = mockGetCreditFacilityStatusSuccess;
function mockGetCreditFacilityStatusFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/credit_facility_status/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetCreditFacilityStatusFailure = mockGetCreditFacilityStatusFailure;
/**
 * No description
 */
function fetchGetDocumentUpload({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetDocumentUpload = fetchGetDocumentUpload;
function mockGetDocumentUploadSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetDocumentUploadSuccess = mockGetDocumentUploadSuccess;
function mockGetDocumentUploadFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetDocumentUploadFailure = mockGetDocumentUploadFailure;
/**
 * No description
 */
function fetchPostDocumentUpload({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/document_upload/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostDocumentUpload = fetchPostDocumentUpload;
function mockPostDocumentUploadSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostDocumentUploadSuccess = mockPostDocumentUploadSuccess;
function mockPostDocumentUploadFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostDocumentUploadFailure = mockPostDocumentUploadFailure;
/**
 * No description
 */
function fetchPutDocumentUpload({ stateKey, documentId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/document_upload/${stateKey}/${documentId}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutDocumentUpload = fetchPutDocumentUpload;
function mockPutDocumentUploadSuccess(stateKey, documentId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/${documentId}/`, "put", 202, data, options);
}
exports.mockPutDocumentUploadSuccess = mockPutDocumentUploadSuccess;
function mockPutDocumentUploadFailure(stateKey, documentId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/document_upload/${stateKey}/${documentId}/`, "put", 400, failureResponse, options);
}
exports.mockPutDocumentUploadFailure = mockPutDocumentUploadFailure;
/**
 * No description
 */
function fetchGetEmailAvailability({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/email_availability/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetEmailAvailability = fetchGetEmailAvailability;
function mockGetEmailAvailabilitySuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/email_availability/`, "get", 200, data, options);
}
exports.mockGetEmailAvailabilitySuccess = mockGetEmailAvailabilitySuccess;
function mockGetEmailAvailabilityFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/email_availability/`, "get", 400, failureResponse, options);
}
exports.mockGetEmailAvailabilityFailure = mockGetEmailAvailabilityFailure;
/**
 * No description
 */
function fetchGetFundingRequirement({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/funding_requirement/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetFundingRequirement = fetchGetFundingRequirement;
function mockGetFundingRequirementSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirement/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetFundingRequirementSuccess = mockGetFundingRequirementSuccess;
function mockGetFundingRequirementFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/funding_requirement/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetFundingRequirementFailure = mockGetFundingRequirementFailure;
/**
 * No description
 */
function fetchGetGeneralDocumentDownload({ documentType, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/general_document/${documentType}/download/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetGeneralDocumentDownload = fetchGetGeneralDocumentDownload;
function mockGetGeneralDocumentDownloadSuccess(documentType, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/general_document/${documentType}/download/`, "get", 200, data, options);
}
exports.mockGetGeneralDocumentDownloadSuccess = mockGetGeneralDocumentDownloadSuccess;
function mockGetGeneralDocumentDownloadFailure(documentType, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/general_document/${documentType}/download/`, "get", 400, failureResponse, options);
}
exports.mockGetGeneralDocumentDownloadFailure = mockGetGeneralDocumentDownloadFailure;
/**
 * Allow a user to authenticate, creating a session id cookie
 */
function fetchPostLogin({ body }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/login/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostLogin = fetchPostLogin;
function mockPostLoginSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login/`, "post", 201, data, options);
}
exports.mockPostLoginSuccess = mockPostLoginSuccess;
function mockPostLoginFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login/`, "post", 400, failureResponse, options);
}
exports.mockPostLoginFailure = mockPostLoginFailure;
/**
 * No description
 */
function fetchGetLoginLink({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/login_link/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetLoginLink = fetchGetLoginLink;
function mockGetLoginLinkSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login_link/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetLoginLinkSuccess = mockGetLoginLinkSuccess;
function mockGetLoginLinkFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/login_link/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetLoginLinkFailure = mockGetLoginLinkFailure;
/**
 * Log a customer out of their account
 */
function fetchPostLogout({ body }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/logout/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostLogout = fetchPostLogout;
function mockPostLogoutSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/logout/`, "post", 201, data, options);
}
exports.mockPostLogoutSuccess = mockPostLogoutSuccess;
function mockPostLogoutFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/logout/`, "post", 400, failureResponse, options);
}
exports.mockPostLogoutFailure = mockPostLogoutFailure;
/**
 * No description
 */
function fetchPostOnfidoSms({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/onfido_sms/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostOnfidoSms = fetchPostOnfidoSms;
function mockPostOnfidoSmsSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido_sms/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostOnfidoSmsSuccess = mockPostOnfidoSmsSuccess;
function mockPostOnfidoSmsFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/onfido_sms/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostOnfidoSmsFailure = mockPostOnfidoSmsFailure;
/**
 * No description
 */
function fetchGetOnlineAccount({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/online_account/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetOnlineAccount = fetchGetOnlineAccount;
function mockGetOnlineAccountSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/online_account/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetOnlineAccountSuccess = mockGetOnlineAccountSuccess;
function mockGetOnlineAccountFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/online_account/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetOnlineAccountFailure = mockGetOnlineAccountFailure;
/**
 * Get information about outstanding CBILS or BBL loans for a given customer.
 */
function fetchGetOutstandingCbilsOrBbl({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/outstanding_cbils_or_bbl/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetOutstandingCbilsOrBbl = fetchGetOutstandingCbilsOrBbl;
function mockGetOutstandingCbilsOrBblSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetOutstandingCbilsOrBblSuccess = mockGetOutstandingCbilsOrBblSuccess;
function mockGetOutstandingCbilsOrBblFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetOutstandingCbilsOrBblFailure = mockGetOutstandingCbilsOrBblFailure;
/**
 * Submit information about outstanding CBILS or BBL loans for a given customer.
 */
function fetchPostOutstandingCbilsOrBbl({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/outstanding_cbils_or_bbl/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostOutstandingCbilsOrBbl = fetchPostOutstandingCbilsOrBbl;
function mockPostOutstandingCbilsOrBblSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostOutstandingCbilsOrBblSuccess = mockPostOutstandingCbilsOrBblSuccess;
function mockPostOutstandingCbilsOrBblFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/outstanding_cbils_or_bbl/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostOutstandingCbilsOrBblFailure = mockPostOutstandingCbilsOrBblFailure;
/**
 * Change a user&#x27;s password, given their old password.
 */
function fetchPostPasswordChange({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password_change/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPasswordChange = fetchPostPasswordChange;
function mockPostPasswordChangeSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password_change/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostPasswordChangeSuccess = mockPostPasswordChangeSuccess;
function mockPostPasswordChangeFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password_change/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordChangeFailure = mockPostPasswordChangeFailure;
/**
 * Given an email address, a user can request a password reset link
 */
function fetchPostPasswordReset({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/password_reset/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPasswordReset = fetchPostPasswordReset;
function mockPostPasswordResetSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password_reset/`, "post", 201, data, options);
}
exports.mockPostPasswordResetSuccess = mockPostPasswordResetSuccess;
function mockPostPasswordResetFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/password_reset/`, "post", 400, failureResponse, options);
}
exports.mockPostPasswordResetFailure = mockPostPasswordResetFailure;
/**
 * No description
 */
function fetchGetPaymentConfirmation({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_confirmation/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetPaymentConfirmation = fetchGetPaymentConfirmation;
function mockGetPaymentConfirmationSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_confirmation/`, "get", 200, data, options);
}
exports.mockGetPaymentConfirmationSuccess = mockGetPaymentConfirmationSuccess;
function mockGetPaymentConfirmationFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_confirmation/`, "get", 400, failureResponse, options);
}
exports.mockGetPaymentConfirmationFailure = mockGetPaymentConfirmationFailure;
/**
 * No description
 */
function fetchPostPaymentConfirmation({ body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/payment_confirmation/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPaymentConfirmation = fetchPostPaymentConfirmation;
function mockPostPaymentConfirmationSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_confirmation/`, "post", 201, data, options);
}
exports.mockPostPaymentConfirmationSuccess = mockPostPaymentConfirmationSuccess;
function mockPostPaymentConfirmationFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_confirmation/`, "post", 400, failureResponse, options);
}
exports.mockPostPaymentConfirmationFailure = mockPostPaymentConfirmationFailure;
/**
 * Retrieve the payment methods linked to the customer.
 */
function fetchGetPaymentMethod({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_method/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetPaymentMethod = fetchGetPaymentMethod;
function mockGetPaymentMethodSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetPaymentMethodSuccess = mockGetPaymentMethodSuccess;
function mockGetPaymentMethodFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetPaymentMethodFailure = mockGetPaymentMethodFailure;
/**
 * Sending a POST request with a valid body will result in creating a chargeable payment method for the specified customer.
 */
function fetchPostPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/payment_method/${stateKey}/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostPaymentMethod = fetchPostPaymentMethod;
function mockPostPaymentMethodSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/`, "post", 201, data, options);
}
exports.mockPostPaymentMethodSuccess = mockPostPaymentMethodSuccess;
function mockPostPaymentMethodFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/`, "post", 400, failureResponse, options);
}
exports.mockPostPaymentMethodFailure = mockPostPaymentMethodFailure;
/**
 * No description
 */
function fetchPutPaymentMethod({ stateKey, paymentMethodId, body, }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/payment_method/${stateKey}/${paymentMethodId}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutPaymentMethod = fetchPutPaymentMethod;
function mockPutPaymentMethodSuccess(stateKey, paymentMethodId, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/${paymentMethodId}/`, "put", 202, data, options);
}
exports.mockPutPaymentMethodSuccess = mockPutPaymentMethodSuccess;
function mockPutPaymentMethodFailure(stateKey, paymentMethodId, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/payment_method/${stateKey}/${paymentMethodId}/`, "put", 400, failureResponse, options);
}
exports.mockPutPaymentMethodFailure = mockPutPaymentMethodFailure;
/**
 * No description
 */
function fetchGetPostcodeLookup({ query, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/postcode_lookup/`, {
        method: "get",
        version: "v1",
        query,
    });
}
exports.fetchGetPostcodeLookup = fetchGetPostcodeLookup;
function mockGetPostcodeLookupSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/postcode_lookup/`, "get", 200, data, options);
}
exports.mockGetPostcodeLookupSuccess = mockGetPostcodeLookupSuccess;
function mockGetPostcodeLookupFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/postcode_lookup/`, "get", 400, failureResponse, options);
}
exports.mockGetPostcodeLookupFailure = mockGetPostcodeLookupFailure;
/**
 * Get payment intents for a given payment method
 */
function fetchGetRepaymentPaymentIntent({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_intent/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetRepaymentPaymentIntent = fetchGetRepaymentPaymentIntent;
function mockGetRepaymentPaymentIntentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "get", 200, data, options);
}
exports.mockGetRepaymentPaymentIntentSuccess = mockGetRepaymentPaymentIntentSuccess;
function mockGetRepaymentPaymentIntentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "get", 400, failureResponse, options);
}
exports.mockGetRepaymentPaymentIntentFailure = mockGetRepaymentPaymentIntentFailure;
/**
 * Create an intent to pay.
 */
function fetchPostRepaymentPaymentIntent({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_intent/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostRepaymentPaymentIntent = fetchPostRepaymentPaymentIntent;
function mockPostRepaymentPaymentIntentSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "post", 201, data, options);
}
exports.mockPostRepaymentPaymentIntentSuccess = mockPostRepaymentPaymentIntentSuccess;
function mockPostRepaymentPaymentIntentFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_intent/`, "post", 400, failureResponse, options);
}
exports.mockPostRepaymentPaymentIntentFailure = mockPostRepaymentPaymentIntentFailure;
/**
 * Get all repayment methods for the given state key
 */
function fetchGetRepaymentPaymentMethod({ stateKey, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_method/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetRepaymentPaymentMethod = fetchGetRepaymentPaymentMethod;
function mockGetRepaymentPaymentMethodSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_method/`, "get", 200, data, options);
}
exports.mockGetRepaymentPaymentMethodSuccess = mockGetRepaymentPaymentMethodSuccess;
function mockGetRepaymentPaymentMethodFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_method/`, "get", 400, failureResponse, options);
}
exports.mockGetRepaymentPaymentMethodFailure = mockGetRepaymentPaymentMethodFailure;
/**
 * Create an intent to add a card or direct debit mandate.
 */
function fetchPostRepaymentPaymentMethod({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/repayment/${stateKey}/payment_method/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostRepaymentPaymentMethod = fetchPostRepaymentPaymentMethod;
function mockPostRepaymentPaymentMethodSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_method/`, "post", 201, data, options);
}
exports.mockPostRepaymentPaymentMethodSuccess = mockPostRepaymentPaymentMethodSuccess;
function mockPostRepaymentPaymentMethodFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/repayment/${stateKey}/payment_method/`, "post", 400, failureResponse, options);
}
exports.mockPostRepaymentPaymentMethodFailure = mockPostRepaymentPaymentMethodFailure;
/**
 * No description
 */
function fetchGetReport({ reportType }) {
    return (0, lendingAPI_1.fetchLendingAPI)(`/report/${reportType}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetReport = fetchGetReport;
function mockGetReportSuccess(reportType, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/report/${reportType}/`, "get", 200, data, options);
}
exports.mockGetReportSuccess = mockGetReportSuccess;
function mockGetReportFailure(reportType, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/report/${reportType}/`, "get", 400, failureResponse, options);
}
exports.mockGetReportFailure = mockGetReportFailure;
/**
 * The POST request should be used to create an iwoca account for the customer. It&#x27;s always the first endpoint and method you should call when submitting a new customer. We&#x27;ll return a state_key used to identify the customer in all future requests. Almost all fields in the State are optional since you can submit a partial application initially, then add or update data over time (through the PUT method). Your iwoca contact will be able to give you details on which fields are recommended to help us make a lending decision.
 */
function fetchPostState({ body }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "post",
        version: "v1",
        body,
    });
}
exports.fetchPostState = fetchPostState;
function mockPostStateSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "post", 201, data, options);
}
exports.mockPostStateSuccess = mockPostStateSuccess;
function mockPostStateFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "post", 400, failureResponse, options);
}
exports.mockPostStateFailure = mockPostStateFailure;
/**
 * No description
 */
function fetchGetStateByStateKey({ stateKey }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetStateByStateKey = fetchGetStateByStateKey;
function mockGetStateByStateKeySuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "get", 200, data, options);
}
exports.mockGetStateByStateKeySuccess = mockGetStateByStateKeySuccess;
function mockGetStateByStateKeyFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "get", 400, failureResponse, options);
}
exports.mockGetStateByStateKeyFailure = mockGetStateByStateKeyFailure;
/**
 * No description
 */
function fetchGetState({}) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/`, {
        method: "get",
        version: "v1",
    });
}
exports.fetchGetState = fetchGetState;
function mockGetStateSuccess(data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "get", 200, data, options);
}
exports.mockGetStateSuccess = mockGetStateSuccess;
function mockGetStateFailure(options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/`, "get", 400, failureResponse, options);
}
exports.mockGetStateFailure = mockGetStateFailure;
/**
 * The PUT request should be used to add or update data for a customer. Note that the entire State should be submitted each time you use this endpoint, even if you are just updating a few fields.
 */
function fetchPutState({ stateKey, body, }) {
    return (0, lendingAPI_1.fetchLendingAPIJSON)(`/state/${stateKey}/`, {
        method: "put",
        version: "v1",
        body,
    });
}
exports.fetchPutState = fetchPutState;
function mockPutStateSuccess(stateKey, data, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "put", 202, data, options);
}
exports.mockPutStateSuccess = mockPutStateSuccess;
function mockPutStateFailure(stateKey, options) {
    return (0, lendingAPIMock_1.mockLendingApi)(`/state/${stateKey}/`, "put", 400, failureResponse, options);
}
exports.mockPutStateFailure = mockPutStateFailure;
